/**
 * Count bookkeeping for the dashboard drill-down modals.
 *
 * Every drill-down count (modal header, table footer) reports how many rows
 * the *current* search + filter selection matches, so the number tracks what
 * the table below it is showing. The counts come from the backend, which
 * re-runs the query on each filter change, and Apollo drops `data` while the
 * new variables are in flight — reading the count straight off the query would
 * therefore blink to 0 between a keystroke and the server's answer, which is
 * indistinguishable from "your filter matched nothing".
 *
 * `nextSettledCount` keeps the last count the server actually returned on
 * screen until a fresh one lands. `undefined` means no count has settled yet
 * (first load), and callers render nothing rather than a placeholder zero.
 */
export function nextSettledCount(
  settled: number | undefined,
  incoming: number | undefined,
  isLoading: boolean
): { changed: boolean; value: number | undefined } {
  if (isLoading || incoming === settled) {
    return { changed: false, value: settled };
  }
  return { changed: true, value: incoming };
}
